
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
 import { useSearchParams } from 'react-router-dom';
 import axios from "axios";

const PaymentStatus = () => {
  const location = useLocation();
  const navigate = useNavigate();
 

const [params] = useSearchParams();
const status = params.get("status");
const payment_id = params.get("payment_id");
const order_id = params.get("order_id");

  // const {
  //   status,           // 'Success' or any status
  //   payment_id,       // Razorpay payment ID
  //   order_id          // Your order ID
  // } = location.state || {};

  useEffect(() => {
  // Clear payment session
  sessionStorage.removeItem("paymentCompleted");

  // Close Razorpay popup if it exists
  if (window.rzpInstance) {
    try {
      window.rzpInstance.close();
      console.log("Razorpay popup closed from payment-status.");
    } catch (err) {
      console.warn("Failed to close Razorpay popup:", err);
    }
    // Optionally clear the instance
    delete window.rzpInstance;
  }
}, []);



  const handleTrackOrder = () => {
    navigate(`/track?id=${order_id}`);
  };

  const handleRetry = async() => {

    const response = await axios.get(`https://api.welbeing.in/payment/razorpay/?id=${order_id}`);
      if (response.data.status === "success"){
         navigate("/payment", {
        state: {
          razId: response.data.data.raz_id,
          amount: response.data.data.grand_total,
          orderId: response.data.data.order_id,
          name: response.data.data.name,
          phone: response.data.data.phonenumber,
          email: response.data.data.email,
          address: response.data.data.address
        }
      });
      } 
   
  };

  const handleGoHome = () => {
    navigate('/');
  };

  const styles = {
    container: {
      margin: 0,
      padding: '30px',
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#ecebef',
      flexDirection: 'column',
      fontFamily: 'Arial, sans-serif',
      textAlign: 'center'
    },
    logo: {
      marginBottom: '20px'
    },
    heading: {
      color: '#608c46',
      fontSize: '20px',
      marginBottom: '20px'
    },
    paragraph: {
      color: '#74747c',
      fontSize: '14px'
    },
    button: {
      backgroundColor: '#4CAF50',
      border: '1px solid #4CAF50',
      color: 'white',
      padding: '15px 32px',
      fontSize: '16px',
      margin: '8px',
      cursor: 'pointer',
      borderRadius: '8px',
      transition: '0.4s'
    },
    buttonHover: {
      backgroundColor: 'white',
      color: 'black',
      border: '1px solid #4CAF50'
    },
    buttonAlt: {
      backgroundColor: 'white',
      border: '1px solid #4CAF50',
      color: 'black',
      padding: '15px 32px',
      fontSize: '16px',
      margin: '8px',
      cursor: 'pointer',
      borderRadius: '8px',
      transition: '0.4s'
    },
    buttonAltHover: {
      backgroundColor: '#4CAF50',
      color: 'white'
    }
  };

  return (
    <div style={styles.container}>
      <img src="/assets/img/logo/logo.png" alt="Logo" style={styles.logo} width={150} />

      {(status === 'Success' || payment_id) ? (
        <>
          <h5 style={styles.heading}>Order Placed!</h5>
          <p style={styles.paragraph}>We will keep you informed with all the details. Thank you!</p>
          <img src="/assets/order/sucsess.gif" alt="Success" width={200} />
          <button
            style={styles.button}
            onMouseOver={e => Object.assign(e.target.style, styles.buttonHover)}
            onMouseOut={e => Object.assign(e.target.style, styles.button)}
            onClick={handleTrackOrder}
          >
            Track Order
          </button>
        </>
      ) : (
        <>
          <h5 style={styles.heading}>Unable to process your request.!</h5>
          <p style={styles.paragraph}>
            Unable to verify your payment details. If any amount was deducted, it will be refunded within 7 days. Thank you!
          </p>
          {order_id && (
            <button
              style={styles.button}
              onMouseOver={e => Object.assign(e.target.style, styles.buttonHover)}
              onMouseOut={e => Object.assign(e.target.style, styles.button)}
              onClick={handleRetry}
            >
              Re-Try Payment
            </button>
          )}
          <button
            style={styles.buttonAlt}
            onMouseOver={e => Object.assign(e.target.style, styles.buttonAltHover)}
            onMouseOut={e => Object.assign(e.target.style, styles.buttonAlt)}
            onClick={handleGoHome}
          >
            Back to Home
          </button>
        </>
      )}
    </div>
  );
};

export default PaymentStatus;
